import { ShowAuthenticationModalProps } from 'authentication/AuthenticationModal';

export const showAuthenticationModal = (
  type: 'signup' | 'login',
  options?: ShowAuthenticationModalProps,
) => {
  $(document).trigger(`show-${type}-auth-modal`, options);
};
